<label [for]="id" class="weight-medium is-uppercase is-size-6"> {{ label }}</label>
<div
  class="field has-addons mt-1"
  [class.adult-ml-underlined]="underlined && classUnderlinedByPassenger === inputAdultValue"
  [class.child-ml-underlined]="underlined && classUnderlinedByPassenger === inputChildValue"
  [class.infant-ml-underlined]="underlined && classUnderlinedByPassenger === inputInfantValue"
>
  <div class="control">
    <input
      #input
      [type]="type"
      [attr.step]="type === 'number' ? '0.01' : null"
      [attr.inputmode]="type === 'number' ? 'decimal' : null"
      [max]="maxLength"
      [min]="minLength"
      [id]="id"
      class="input is-medium"
      [class.disabled-input]="disabled"
      [disabled]="disabled"
      [placeholder]="placeholder"
      [ngModel]="displayValue"
      (ngModelChange)="updateValue($event)"
      autocomplete="off"
      (focus)="whereIsFocusedElement(id)"
      (blur)="restoreUnderlinedClass()"
    />
  </div>
  <div class="control" *ngIf="!isStatic; else static">
    <span class="select is-medium">
      <select
        id="select{{ id }}"
        [class.disabled-input]="disabled"
        [disabled]="disabled"
        [(ngModel)]="valueSelect"
        (change)="changeSelect.emit(valueSelect)"
      >
        <ng-container *ngIf="currencies">
          <option *ngFor="let value of currencies" [value]="value?.isoCode">
            {{ value?.isoCode }}
          </option>
        </ng-container>
        <ng-container *ngIf="!isGroup && !currencies; else groupValues">
          <option *ngFor="let value of valuesAddon" [value]="value">{{ value }}</option>
        </ng-container>
        <optgroup
          #groupValues
          *ngFor="let group of valuesGroupAddon"
          label="{{ 'select-inputs.' + group.name | translate }}"
        >
          <option *ngFor="let value of group.options" [value]="value">{{ value }}</option>
        </optgroup>
      </select>
    </span>
  </div>
</div>
<p *ngIf="(input.touched && input.invalid) || error" class="help is-danger">
  {{ errorMessage }}
</p>

<ng-template #static>
  <p class="control">
    <a class="button is-medium disabled-input is-full-height is-size-6">
      {{ staticText }}
    </a>
  </p>
</ng-template>
